import { Component, ChangeDetectionStrategy } from '@angular/core';
import {MetaTitle} from '../../../../decorator/meta-title';

@Component({
  selector: 'app-notifications',
  imports: [],
  templateUrl: './notifications.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './notifications.component.scss'
})
@MetaTitle('Notifications')
export class NotificationsComponent {

}
